// src/services/api.js
import axios from "axios";

// Create a reusable axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true, // same as credentials: "include"
  headers: {
    "Content-Type": "application/json",
  },
});

// Add response handler
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;

    // Session expired or not authenticated — redirect to login
    if (status === 401) {
      const currentPath = window.location.pathname + window.location.search;
      const publicPages = [
        "/login", "/register", "/verify-otp", "/forgot-password",
        "/reset-password", "/invites/accept", "/account-suspended", "/terms",
      ];
      const isPublicPage = publicPages.some(
        (p) => window.location.pathname === p || window.location.pathname.startsWith(p + "/")
      );
      if (!isPublicPage) {
        window.location.replace(`/login?expired=1&from=${encodeURIComponent(currentPath)}`);
      }
      return Promise.reject(new Error("Session expired"));
    }

    const message = error.response?.data?.message || "Request error";
    return Promise.reject(
      Object.assign(new Error(message), {
        status,
        data: error.response?.data,
      })
    );
  }
);

export const api = {
  get: (path, config = {}) => apiClient.get(path, config),
  post: (path, body, config = {}) => apiClient.post(path, body, config),
  put: (path, body, config = {}) => apiClient.put(path, body, config),
  delete: (path, config = {}) => apiClient.delete(path, config),
};
